var globals = {};
var njm = {};
var bbGEvent = bbGEvent || _.extend({}, Backbone.Events);

/**
 * Backbone Objects
 */
njm.views = njm.views || {};
njm.models = njm.models || {};
njm.collections = njm.collections || {};
njm.routers = njm.routers || {};

/**
 * Define the devices resolution supported
 */
globals.media = {
    default: 'desktop',
    devices: {
        mobile: [0, 767],
        tablet: [768, 1044],
        desktop: [1045, 10000]
    }
};

/*jshint unused:false*/
/**
 * Initialize Data Layer for Google Tag Manager
 * @type {Array}
 */
var dataLayer = window.dataLayer || [];

/**
 * Cover Image support for IE11
 */
if ('objectFit' in document.documentElement.style === false) {

    // assign HTMLCollection with parents of images with objectFit to variable
    var container = document.getElementsByClassName('cover-img');

    // Loop through HTMLCollection
    for (var i = 0; i < container.length; i++) {

        // Asign image source to variable
        var imageSource = container[i].querySelector('img').src;

        // Hide image
        container[i].querySelector('img').style.display = 'none';

        // Add background-size: cover
        container[i].style.backgroundSize = 'cover';

        // Add background-image: and put image source here
        container[i].style.backgroundImage = 'url(' + imageSource + ')';

        // Add background-position: center center
        container[i].style.backgroundPosition = 'center center';
    }
}

//Globally update Timestamp in site.

function processUrl(url) {
    try {
        //const urlObj = new URL(url, window.location.origin); // Ensure it's a valid URL
        const currentTimestamp = Date.now();
        const dcTimeOut = 5 * 60 * 1000; // 5 minutes timeout

        let gotoParam = url.searchParams.get("goto"); // Get 'goto' parameter
        // If 'goto' exist, check and update 'dc' in the goto URL
        if (gotoParam) {
            try {
                // Decode 'goto' safely and parse it as a URL
                let gotoUrl = new URL(gotoParam, window.location.origin);
                let gotoDc = gotoUrl.searchParams.get("_dc");
                // If 'dc' is missing in 'goto' or expired, update it
                if (!gotoDc || currentTimestamp - parseInt(gotoDc) > dcTimeOut) {
                    gotoUrl.searchParams.set("_dc", currentTimestamp);
                }

                // Update 'goto' parameter with the modified URL (not encoded)
                url.searchParams.set("goto", gotoUrl.toString());
            } catch (e) {
                console.warn("Invalid 'goto' URL:", gotoParam, e);
            }
        }

        // If 'goto' doesn't exist, check and update 'dc' in the main URL
        let mainDc = url.searchParams.get("_dc");
        if (!gotoParam && (!mainDc || currentTimestamp - parseInt(mainDc) > dcTimeOut)) {
            url.searchParams.set("_dc", currentTimestamp);
        }
        return url.toString(); // Return final URL without extra encoding
    }
    catch (error) {
        console.error("Error processing URL:", error);
        return url; // Return original URL in case of an error
    }
}
function urlParam(name, param) {
    var paramCheck;
    name = name.toLowerCase();

    if (!param) {
        var location = window.location.search,
            index = location.indexOf('=');
        paramCheck = location.substring(0, index).toLowerCase() + location.substring(index);
    }
    else paramCheck = param;

    var results = new RegExp('[\?&]' + name + '=([^&#]*)')
        .exec(paramCheck);

    return (results !== null) ? results[1] || 0 : false;
}

function updateTimeStamp() {
    const currentTimestamp = Date.now();

    try {
        // Scenario 1: Update {ts} in anchor tag URLs
        document.querySelectorAll("a[href*='{ts}']").forEach((anchor) => {
            anchor.href = anchor.href.replace(/{ts}/g, currentTimestamp);
            // Force UI update
            const newAnchor = anchor.cloneNode(true);
            anchor.parentNode.replaceChild(newAnchor, anchor);
        });

        // Scenario 2: Update {ts} in the browser URL if present
        let currentUrl = window.location.href;
        if (currentUrl.includes("{ts}")) {
            const updatedUrl = currentUrl.replace(/{ts}/g, currentTimestamp);
            window.history.replaceState(null, null, updatedUrl);
        }

        // Scenario 3: Handle .dc parameter for /cssportal/ URLs
        if (currentUrl.includes("/cssportal/")) {
            if (typeof processUrl === "function") { // Ensure function exists
                const processedUrl = processUrl(currentUrl);
                window.history.replaceState(null, null, processedUrl);
            } else {
                console.warn("processUrl function is missing.");
            }
        }

    } catch (error) {
        console.error("Error updating timestamp:", error);
    }
}

// Handle dynamically added elements
const observer = new MutationObserver(() => updateTimeStamp());
observer.observe(document.body, { childList: true, subtree: true });

// Call function initially
updateTimeStamp();



